module.exports = __webpack_public_path__ + "img/php.503431e0.png";